import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  Input,
  Output, EventEmitter
} from '@angular/core';
import { MediaCell } from '../../carousel-media-cell/carousel-media-cell.component';

@Component({
  selector: 'lib-video-wrapper',
  templateUrl: './video-wrapper.component.html',
  styleUrls: ['./video-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoWrapperComponent {
  @ViewChild('vid') vid!: ElementRef;
  @Output() isLoadingEmitter: EventEmitter<boolean> = new EventEmitter();

  @Input() objectFit: string = '';
  @Input()
  get video(): MediaCell { return this._video }
  set video(val: MediaCell) {
    this._video = { ...this.video, ...val };
  }
  errorOccurred = false;
  private _video: MediaCell = { src: '', loading: true, type: 'video' };
  constructor() { }
  ngOnInit() {
    this.isLoadingEmitter?.emit(true)
  }
  setCanPlay(event: any) {
    this._video.thumbnail = this.video.src;
    this._video.loading = false;
    this.isLoadingEmitter.emit(false)
  }

  error() {
    this._video.loading = false;
    this.errorOccurred = true;
    this.isLoadingEmitter.emit(false)
  }

}
